module.exports = __webpack_public_path__ + "img/phonekaka2.368366dc.png";